module.exports = __webpack_public_path__ + "static/media/user-solid-dark.0d08f921.png";